import { BaseRoleRepositoryImpl } from '@/features/baseRole/data/repositories/BaseRoleRepositoryImpl'
import { PolicyRepositoryImpl } from '@/features/baseRole/data/repositories/PolicyRepositoryImpl'
import type { BaseRoleRepository } from '@/features/baseRole/domain/repositories/BaseRoleRepository'
import type { PolicyRepository } from '@/features/baseRole/domain/repositories/PolicyRepository'

import { RoleRepositoryImpl } from '@/features/role/data/repositories/RoleRepositoryImpl'
import type { RoleRepository } from '@/features/role/domain/repositories/RoleRepository'

import { PanelSettingRepositoryImpl } from '@/features/panelSetting/data/repositories/PanelSettingRepositoryImpl'
import type { PanelSettingRepository } from '@/features/panelSetting/domain/repositories/PanelSettingRepository'

import { TranslationRepositoryImpl } from '@/features/translation/data/repositories/TranslationRepositoryImpl'
import type { TranslationRepository } from '@/features/translation/domain/repositories/TranslationRepository'

import { CancelOrderReasonRepositoryImpl } from '@/features/cancelOrderReason/data/repositories/CancelOrderReasonRepositoryImpl'
import type { CancelOrderReasonRepository } from '@/features/cancelOrderReason/domain/repositories/CancelOrderReasonRepository'

import { ServiceRepositoryImpl } from '@/features/service/data/repositories/ServiceRepositoryImpl'
import type { ServiceRepository } from '@/features/service/domain/repositories/ServiceRepository'

import { RegionRepositoryImpl } from '@/features/region/data/repositories/RegionRepositoryImpl'
import type { RegionRepository } from '@/features/region/domain/repositories/RegionRepository'

import { VenderRepositoryImpl } from '@/features/vender/data/repositories/VenderRepositoryImpl'
import type { VenderRepository } from '@/features/vender/domain/repositories/VenderRepository'

import { CategoryRepositoryImpl } from '@/features/category/data/repositories/CategoryRepositoryImpl'
import type { CategoryRepository } from '@/features/category/domain/repositories/CategoryRepository'

import { UserRepositoryImpl } from '@/features/user/data/repositories/UserRepositoryImpl'
import type { UserRepository } from '@/features/user/domain/repositories/UserRepository'
import type { BrandRepository } from '@/features/brand/domain/repositories/BrandRepository'
import { BrandRepositoryImpl } from '@/features/brand/data/repositories/BrandRepositoryImpl'

import { ItemRepositoryImpl } from '@/features/item/data/repositories/ItemRepositoryImpl'
import type { ItemRepository } from '@/features/item/domain/repositories/ItemRepository'

import { BranchRepositoryImpl } from '@/features/branch/data/repositories/BranchRepositoryImpl'
import type { BranchRepository } from '@/features/branch/domain/repositories/BranchRepository'

import { OrderRepositoryImpl } from '@/features/order/data/repositories/OrderRepositoryImpl'
import type { OrderRepository } from '@/features/order/domain/repositories/OrderRepository'

import { DiscountOfferRepositoryImpl } from '@/features/discountOffer/data/repositories/DiscountOfferRepositoryImpl'
import type { DiscountOfferRepository } from '@/features/discountOffer/domain/repositories/DiscountOfferRepository'

import { DashboardRepositoryImpl } from '@/features/dashboard/data/repositories/DashboardRepositoryImpl'
import type { DashboardRepository } from '@/features/dashboard/domain/repositories/DashboardRepository'
import type { AuthenticationRepository } from '@/features/authentication/domain/repositories/AuthenticationRepository'
import { AuthenticationRepositoryImpl } from '@/features/authentication/data/repositories/AuthenticationRepositoryImpl'
import type { CurrentUserRepository } from '@/features/currentUser/domain/repositories/CurrentUserRepository'
import { CurrentUserRepositoryImpl } from '@/features/currentUser/data/repositories/CurrentUserRepositoryImpl'

import { ChannelRepositoryImpl } from '@/features/channel/data/repositories/ChannelRepositoryImpl'
import type { ChannelRepository } from '@/features/channel/domain/repositories/ChannelRepository'
import { ChannelWorkingHoursRepositoryImpl } from '@/features/channel/data/repositories/ChannelWorkingHoursRepositoryImpl'
import type { ChannelWorkingHoursRepository } from '@/features/channel/domain/repositories/ChannelWorkingHoursRepository'

import { CanceledOrderRepositoryImpl } from '@/features/canceledOrder/data/repositories/CanceledOrderRepositoryImpl'
import type { CanceledOrderRepository } from '@/features/canceledOrder/domain/repositories/CanceledOrderRepository'

import { NoteRepositoryImpl } from '@/features/note/data/repositories/NoteRepositoryImpl'
import type { NoteRepository } from '@/features/note/domain/repositories/NoteRepository'

import { BranchTagsRepositoryImpl } from '@/features/branchTags/data/repositories/BranchTagsRepositoryImpl'
import type { BranchTagsRepository } from '@/features/branchTags/domain/repositories/BranchTagsRepository'

import { SelectionRepositoryImpl } from '@/features/selection/data/repositories/SelectionRepositoryImpl'
import type { SelectionRepository } from '@/features/selection/domain/repositories/SelectionRepository'

import { OrdersStreamRepositoryImpl } from '@/features/ordersStream/data/repositories/OrdersStreamRepositoryImpl'
import type { OrdersStreamRepository } from '@/features/ordersStream/domain/repositories/OrdersStreamRepository'

import { OrderRateRepositoryImpl } from '@/features/orderRate/data/repositories/OrderRateRepositoryImpl'
import type { OrderRateRepository } from '@/features/orderRate/domain/repositories/OrderRateRepository'

import { ShowcaseRepositoryImpl } from '@/features/showcase/data/repositories/ShowcaseRepositoryImpl'
import type { ShowcaseRepository } from '@/features/showcase/domain/repositories/ShowcaseRepository'

import { ChannelUserRepositoryImpl } from '@/features/channelUser/data/repositories/ChannelUserRepositoryImpl'
import type { ChannelUserRepository } from '@/features/channelUser/domain/repositories/ChannelUserRepository'

import { CardRepositoryImpl } from '@/features/card/data/repositories/CardRepositoryImpl'
import type { CardRepository } from '@/features/card/domain/repositories/CardRepository'

import { ActivityLogRepositoryImpl } from '@/features/activityLog/data/repositories/ActivityLogRepositoryImpl'
import type { ActivityLogRepository } from '@/features/activityLog/domain/repositories/ActivityLogRepository'
import { OperatorPriceChangeRepositoryImpl } from '@/features/operatorPriceChange/data/repositories/OperatorPriceChangeRepositoryImpl'
import type { OperatorPriceChangeRepository } from '@/features/operatorPriceChange/domain/repositories/OperatorPriceChangeRepository'

import { DisableBranchRepositoryImpl } from '@/features/disableBranch/data/repositories/DisableBranchRepositoryImpl'
import type { DisableBranchRepository } from '@/features/disableBranch/domain/repositories/DisableBranchRepository'

import { DriverRepositoryImpl } from '@/features/driver/data/repositories/DriverRepositoryImpl'
import type { DriverRepository } from '@/features/driver/domain/repositories/DriverRepository'

import { DriverDocumentRepositoryImpl } from '@/features/driverDocument/data/repositories/DriverDocumentRepositoryImpl'
import type { DriverDocumentRepository } from '@/features/driverDocument/domain/repositories/DriverDocumentRepository'

import { DriverBlockRepositoryImpl } from '@/features/driverBlock/data/repositories/DriverBlockRepositoryImpl'
import type { DriverBlockRepository } from '@/features/driverBlock/domain/repositories/DriverBlockRepository'
import { DriverBreakRepositoryImpl } from '@/features/driverBreak/data/repositories/DriverBreakRepositoryImpl'
import type { DriverBreakRepository } from '@/features/driverBreak/domain/repositories/DriverBreakRepository'
import { DriverDayOffRepositoryImpl } from '@/features/driverDayOff/data/repositories/DriverDayOffRepositoryImpl'
import type { DriverDayOffRepository } from '@/features/driverDayOff/domain/repositories/DriverDayOffRepository'
import { DriverPenaltyRepositoryImpl } from '@/features/driverPenalty/data/repositories/DriverPenaltyRepositoryImpl'
import type { DriverPenaltyRepository } from '@/features/driverPenalty/domain/repositories/DriverPenaltyRepository'
import { DriverRankingRepositoryImpl } from '@/features/driverRanking/data/repositories/DriverRankingRepositoryImpl'
import type { DriverRankingRepository } from '@/features/driverRanking/domain/repositories/DriverRankingRepository'
import { DriverDailyMetricRepositoryImpl } from '@/features/driverDailyMetric/data/repositories/DriverDailyMetricRepositoryImpl'
import type { DriverDailyMetricRepository } from '@/features/driverDailyMetric/domain/repositories/DriverDailyMetricRepository'
import { DriverMetricAdjustmentRepositoryImpl } from '@/features/driverMetricAdjustment/data/repositories/DriverMetricAdjustmentRepositoryImpl'
import type { DriverMetricAdjustmentRepository } from '@/features/driverMetricAdjustment/domain/repositories/DriverMetricAdjustmentRepository'
import { RegionDailyAverageRepositoryImpl } from '@/features/regionDailyAverage/data/repositories/RegionDailyAverageRepositoryImpl'
import type { RegionDailyAverageRepository } from '@/features/regionDailyAverage/domain/repositories/RegionDailyAverageRepository'
import { DriverRankTierConfigRepositoryImpl } from '@/features/driverRankTierConfig/data/repositories/DriverRankTierConfigRepositoryImpl'
import type { DriverRankTierConfigRepository } from '@/features/driverRankTierConfig/domain/repositories/DriverRankTierConfigRepository'
import { DriverRankSettingRepositoryImpl } from '@/features/driverRankSetting/data/repositories/DriverRankSettingRepositoryImpl'
import type { DriverRankSettingRepository } from '@/features/driverRankSetting/domain/repositories/DriverRankSettingRepository'
import { DriverEarningSettingRepositoryImpl } from '@/features/driverEarningSetting/data/repositories/DriverEarningSettingRepositoryImpl'
import type { DriverEarningSettingRepository } from '@/features/driverEarningSetting/domain/repositories/DriverEarningSettingRepository'
import type { SystemSalaryRepository } from '@/features/systemSalary/domain/repositories/SystemSalaryRepository'
import { SystemSalaryRepositoryImpl } from '@/features/systemSalary/data/repositories/SystemSalaryRepositoryImpl'
import type { VehicleTemplateRepository } from '@/features/vehicleTemplate/domain/repositories/VehicleTemplateRepository'
import { VehicleTemplateRepositoryImpl } from '@/features/vehicleTemplate/data/repositories/VehicleTemplateRepositoryImpl'
import type { CancelShipmentReasonRepository } from '@/features/cancelShipmentReason/domain/repositories/CancelShipmentReasonRepository'
import { CancelShipmentReasonRepositoryImpl } from '@/features/cancelShipmentReason/data/repositories/CancelShipmentReasonRepositoryImpl'
import { DistrictRepositoryImpl } from '@/features/district/data/repositories/DistrictRepositoryImpl'
import type { DistrictRepository } from '@/features/district/domain/repositories/DistrictRepository'
import { JobRepositoryImpl } from '@/features/job/data/repositories/JobRepositoryImpl'
import type { JobRepository } from '@/features/job/domain/repositories/JobRepository'
import type { OrderRateReasonRepository } from '@/features/orderRateReason/domain/repositories/OrderRateReasonRepository'
import { OrderRateReasonRepositoryImpl } from '@/features/orderRateReason/data/repositories/OrderRateReasonRepositoryImpl'
import { ShiftRepositoryImpl } from '@/features/shift/data/repositories/ShiftRepositoryImpl'
import type { ShiftRepository } from '@/features/shift/domain/repositories/ShiftRepository'
import { ShiftTemplateRepositoryImpl } from '@/features/shiftTemplate/data/repositories/ShiftTemplateRepositoryImpl'
import type { ShiftTemplateRepository } from '@/features/shiftTemplate/domain/repositories/ShiftTemplateRepository'
import type { ShiftSettingRepository } from '@/features/shiftSetting/domain/repositories/ShiftSettingRepository'
import { ShiftSettingRepositoryImpl } from '@/features/shiftSetting/data/repositories/ShiftSettingRepositoryImpl'
import type { ShipmentRepository } from '@/features/shipment/domain/repositories/ShipmentRepository'
import { ShipmentRepositoryImpl } from '@/features/shipment/data/repositories/ShipmentRepositoryImpl'
import { TrackOrderRepositoryImpl } from '@/features/trackOrder/data/repositories/TrackOrderRepositoryImpl'
import type { TrackOrderRepository } from '@/features/trackOrder/domain/repositories/TrackOrderRepository'
import { TrackOrderRepositoryImpl as TrackOrderTwoRepositoryImpl } from '@/features/trackOrderTwo/data/repositories/TrackOrderRepositoryImpl'
import type { TrackOrderRepository as TrackOrderTwoRepository } from '@/features/trackOrderTwo/domain/repositories/TrackOrderRepository'
import type { PouchRepository } from '@/features/pouch/domain/repositories/PouchRepository'
import { PouchRepositoryImpl } from '@/features/pouch/data/repositories/PouchRepositoryImpl'
import { SearchSettingRepositoryImpl } from '@/features/searchSetting/data/repositories/SearchSettingRepositoryImpl'
import type { SearchSettingRepository } from '@/features/searchSetting/domain/repositories/SearchSettingRepository'
import type { DriverTeamRepository } from '@/features/driverTeam/domain/repositories/DriverTeamRepository'
import { DriverTeamRepositoryImpl } from '@/features/driverTeam/data/repositories/DriverTeamRepositoryImpl'
import { OrderCancellationPolicyRepositoryImpl } from '@/features/orderCancellationPolicy/data/repositories/OrderCancellationPolicyRepositoryImpl'
import type { OrderCancellationPolicyRepository } from '@/features/orderCancellationPolicy/domain/repositories/OrderCancellationPolicyRepository'

import { CouponsRepositoryImpl } from '@/features/coupons/data/repositories/CouponsRepositoryImpl'
import type { CouponsRepository } from '@/features/coupons/domain/repositories/CouponsRepository'

import { CampaignsRepositoryImpl } from '@/features/campaigns/data/repositories/CampaignsRepositoryImpl'
import type { CampaignsRepository } from '@/features/campaigns/domain/repositories/CampaignsRepository'
import { CashbackRepositoryImpl } from '@/features/cashback/data/repositories/CashbackRepositoryImpl'
import type { CashbackRepository } from '@/features/cashback/domain/repositories/CashbackRepository'

import { ChatRepositoryImpl } from '@/features/chat/data/repositories/ChatRepositoryImpl'
import type { ChatRepository } from '@/features/chat/domain/repositories/ChatRepository'

import { UserGroupRepositoryImpl } from '@/features/userGroup/data/repositories/UserGroupRepositoryImpl'
import type { UserGroupRepository } from '@/features/userGroup/domain/repositories/UserGroupRepository'

import { PrizeRepositoryImpl } from '@/features/prize/data/repositories/PrizeRepositoryImpl'
import type { PrizeRepository } from '@/features/prize/domain/repositories/PrizeRepository'

import { SpinWheelRepositoryImpl } from '@/features/spinWheel/data/repositories/SpinWheelRepositoryImpl'
import type { SpinWheelRepository } from '@/features/spinWheel/domain/repositories/SpinWheelRepository'

import { PouchOperationRepositoryImpl } from '@/features/pouchOperation/data/repositories/PouchOperationRepositoryImpl'
import type { PouchOperationRepository } from '@/features/pouchOperation/domain/repositories/PouchOperationRepository'

import { UserNoteRepositoryImpl } from '@/features/userNote/data/repositories/UserNoteRepositoryImpl'
import type { UserNoteRepository } from '@/features/userNote/domain/repositories/UserNoteRepository'

import { SalesManRepositoryImpl } from '@/features/salesMan/data/repositories/SalesManRepositoryImpl'
import type { SalesManRepository } from '@/features/salesMan/domain/repositories/SalesManRepository'

import { ItemUnitsRepositoryImpl } from '@/features/ItemUnits/data/repositories/ItemUnitsRepositoryImpl'
import type { ItemUnitsRepository } from '@/features/ItemUnits/domain/repositories/ItemUnitsRepository'

import { BranchDeliverySettingRepositoryImpl } from '@/features/branchDeliverySetting/data/repositories/BranchDeliverySettingRepositoryImpl'
import type { BranchDeliverySettingRepository } from '@/features/branchDeliverySetting/domain/repositories/BranchDeliverySettingRepository'

import { UserAddressRepositoryImpl } from '@/features/userAddress/data/repositories/UserAddressRepositoryImpl'
import type { UserAddressRepository } from '@/features/userAddress/domain/repositories/UserAddressRepository'

import { ZohoValueRepositoryImpl } from '@/features/zohoValue/data/repositories/ZohoValueRepositoryImpl'
import type { ZohoValueRepository } from '@/features/zohoValue/domain/repositories/ZohoValueRepository'

import { CustomMessageRepositoryImpl } from '@/features/customMessage/data/repositories/CustomMessageRepositoryImpl'
import type { CustomMessageRepository } from '@/features/customMessage/domain/repositories/CustomMessageRepository'

import { OrderPaymentTypeRepositoryImpl } from '@/features/orderPaymentType/data/repositories/OrderPaymentTypeRepositoryImpl'
import type { OrderPaymentTypeRepository } from '@/features/orderPaymentType/domain/repositories/OrderPaymentTypeRepository'


import { MealTiersRepositoryImpl } from '@/features/mealTiers/data/repositories/MealTiersRepositoryImpl'
import type { MealTiersRepository } from '@/features/mealTiers/domain/repositories/MealTiersRepository'

import { CompaniesRepositoryImpl } from '@/features/companies/data/repositories/CompaniesRepositoryImpl'
import type { CompaniesRepository } from '@/features/companies/domain/repositories/CompaniesRepository'

import { CompanyUsersRepositoryImpl } from '@/features/companyUsers/data/repositories/CompanyUsersRepositoryImpl'
import type { CompanyUsersRepository } from '@/features/companyUsers/domain/repositories/CompanyUsersRepository'

import { MealRepositoryImpl } from '@/features/meal/data/repositories/MealRepositoryImpl'
import type { MealRepository } from '@/features/meal/domain/repositories/MealRepository'
import { ScheduledProgramRepositoryImpl } from '@/features/scheduledMyMeal/data/repositories/ScheduledProgramRepositoryImpl'
import type { ScheduledProgramRepository } from '@/features/scheduledMyMeal/domain/repositories/ScheduledProgramRepository'

import { CancelMealReasonRepositoryImpl } from '@/features/cancelMealReason/data/repositories/CancelMealReasonRepositoryImpl'
import type { CancelMealReasonRepository } from '@/features/cancelMealReason/domain/repositories/CancelMealReasonRepository'

import { CancelPackageReasonRepositoryImpl } from '@/features/cancelPackageReason/data/repositories/CancelPackageReasonRepositoryImpl'
import type { CancelPackageReasonRepository } from '@/features/cancelPackageReason/domain/repositories/CancelPackageReasonRepository'

import { AdjustmentRepositoryImpl } from '@/features/adjustment/data/repositories/AdjustmentRepositoryImpl'
import type { AdjustmentRepository } from '@/features/adjustment/domain/repositories/AdjustmentRepository'
import { AdjustmentReasonRepositoryImpl } from '@/features/adjustmentReason/data/repositories/AdjustmentReasonRepositoryImpl'
import type { AdjustmentReasonRepository } from '@/features/adjustmentReason/domain/repositories/AdjustmentReasonRepository'

import { ExternalBranchesRepositoryImpl } from '@/features/externalBranches/data/repositories/ExternalBranchesRepositoryImpl'
import type { ExternalBranchesRepository } from '@/features/externalBranches/domain/repositories/ExternalBranchesRepository'

import { CancelDeliveryReasonRepositoryImpl } from '@/features/cancelDeliveryReason/data/repositories/CancelDeliveryReasonRepositoryImpl'
import type { CancelDeliveryReasonRepository } from '@/features/cancelDeliveryReason/domain/repositories/CancelDeliveryReasonRepository'

import { PackageRepositoryImpl } from '@/features/package/data/repositories/PackageRepositoryImpl'
import type { PackageRepository } from '@/features/package/domain/repositories/PackageRepository'

import { ReminderSettingRepositoryImpl } from '@/features/reminderSetting/data/repositories/ReminderSettingRepositoryImpl'
import type { ReminderSettingRepository } from '@/features/reminderSetting/domain/repositories/ReminderSettingRepository'

import { MenuScreenRepositoryImpl } from '@/features/driverMenuConfig/data/repositories/MenuScreenRepositoryImpl'
import type { MenuScreenRepository } from '@/features/driverMenuConfig/domain/repositories/MenuScreenRepository'
import { RegionMenuSettingRepositoryImpl } from '@/features/driverMenuConfig/data/repositories/RegionMenuSettingRepositoryImpl'
import type { RegionMenuSettingRepository } from '@/features/driverMenuConfig/domain/repositories/RegionMenuSettingRepository'

import { LiveMealRepositoryImpl as LiveMealRepositoryImplV2 } from '@/features/liveMealV2/data/repositories/LiveMealRepositoryImpl'
import type { LiveMealRepository as LiveMealRepositoryV2 } from '@/features/liveMealV2/domain/repositories/LiveMealRepository'

import { LiveMealRepositoryImpl } from '@/features/liveMeal/data/repositories/LiveMealRepositoryImpl'
import type { LiveMealRepository } from '@/features/liveMeal/domain/repositories/LiveMealRepository'

import { LivePackageRepositoryImpl } from '@/features/livePackage/data/repositories/LivePackageRepositoryImpl'
import type { LivePackageRepository } from '@/features/livePackage/domain/repositories/LivePackageRepository'

import { LivePackageRepositoryImpl as LivePackageRepositoryImplV2 } from '@/features/livePackageV2/data/repositories/LivePackageRepositoryImpl'
import type { LivePackageRepository as LivePackageRepositoryV2 } from '@/features/livePackageV2/domain/repositories/LivePackageRepository'

import { RegionDeliveryRangeSettingRepositoryImpl } from '@/features/regionDeliveryRangeSetting/data/repositories/RegionDeliveryRangeSettingRepositoryImpl'
import type { RegionDeliveryRangeSettingRepository } from '@/features/regionDeliveryRangeSetting/domain/repositories/RegionDeliveryRangeSettingRepository'

import { MealCategoryRepositoryImpl } from '@/features/mealCategory/data/repositories/MealCategoryRepositoryImpl'
import type { MealCategoryRepository } from '@/features/mealCategory/domain/repositories/MealCategoryRepository'

import { TrendingSearchRepositoryImpl } from '@/features/trendingSearch/data/repositories/TrendingSearchRepositoryImpl'
import type { TrendingSearchRepository } from '@/features/trendingSearch/domain/repositories/TrendingSearchRepository'

import { BranchPinRepositoryImpl } from '@/features/branchPin/data/repositories/BranchPinRepositoryImpl'
import type { BranchPinRepository } from '@/features/branchPin/domain/repositories/BranchPinRepository'

import { DeliveryDiscountRepositoryImpl } from '@/features/deliveryDiscount/data/repositories/DeliveryDiscountRepositoryImpl'
import type { DeliveryDiscountRepository } from '@/features/deliveryDiscount/domain/repositories/DeliveryDiscountRepository'

import { BranchMinimumCartSystemRepositoryImpl } from '@/features/branchMinimumCartSystem/data/repositories/BranchMinimumCartSystemRepositoryImpl'
import type { BranchMinimumCartSystemRepository } from '@/features/branchMinimumCartSystem/domain/repositories/BranchMinimumCartSystemRepository'
class ServiceLocator {
  private services: Map<string, unknown>

  constructor() {
    this.services = new Map()
  }

  // Register a service
  registerService<T>(key: string, service: T): void {
    this.services.set(key, service)
  }

  // Retrieve a service
  getService<T>(key: string): T | undefined {
    return this.services.get(key) as T // Cast to T to ensure type safety
  }
}

// Create a global service locator instance
export const serviceLocator = new ServiceLocator()

serviceLocator.registerService<BaseRoleRepository>('BaseRoleService', new BaseRoleRepositoryImpl())
serviceLocator.registerService<PolicyRepository>('PolicyService', new PolicyRepositoryImpl())

serviceLocator.registerService<RoleRepository>('RoleService', new RoleRepositoryImpl())
serviceLocator.registerService<CurrentUserRepository>(
  'CurrentUserService',
  new CurrentUserRepositoryImpl()
)
serviceLocator.registerService<PanelSettingRepository>(
  'PanelSettingService',
  new PanelSettingRepositoryImpl()
)

serviceLocator.registerService<TranslationRepository>(
  'TranslationService',
  new TranslationRepositoryImpl()
)

serviceLocator.registerService<CancelOrderReasonRepository>(
  'CancelOrderReasonService',
  new CancelOrderReasonRepositoryImpl()
)

serviceLocator.registerService<ServiceRepository>('ServiceService', new ServiceRepositoryImpl())

serviceLocator.registerService<RegionRepository>('RegionService', new RegionRepositoryImpl())

serviceLocator.registerService<VenderRepository>('VenderService', new VenderRepositoryImpl())

serviceLocator.registerService<CategoryRepository>('CategoryService', new CategoryRepositoryImpl())

serviceLocator.registerService<UserRepository>('UserService', new UserRepositoryImpl())

serviceLocator.registerService<BrandRepository>('BrandService', new BrandRepositoryImpl())

serviceLocator.registerService<ItemRepository>('ItemService', new ItemRepositoryImpl())
serviceLocator.registerService<AuthenticationRepository>(
  'AuthenticationService',
  new AuthenticationRepositoryImpl()
)
serviceLocator.registerService<BranchRepository>('BranchService', new BranchRepositoryImpl())

serviceLocator.registerService<OrderRepository>('OrderService', new OrderRepositoryImpl())

serviceLocator.registerService<DiscountOfferRepository>(
  'DiscountOfferService',
  new DiscountOfferRepositoryImpl()
)

serviceLocator.registerService<DashboardRepository>(
  'DashboardService',
  new DashboardRepositoryImpl()
)

serviceLocator.registerService<ChannelRepository>('ChannelService', new ChannelRepositoryImpl())
serviceLocator.registerService<ChannelWorkingHoursRepository>(
  'ChannelWorkingHoursService',
  new ChannelWorkingHoursRepositoryImpl()
)

serviceLocator.registerService<CanceledOrderRepository>(
  'CanceledOrderService',
  new CanceledOrderRepositoryImpl()
)

serviceLocator.registerService<NoteRepository>('NoteService', new NoteRepositoryImpl())

serviceLocator.registerService<BranchTagsRepository>(
  'BranchTagsService',
  new BranchTagsRepositoryImpl()
)

serviceLocator.registerService<SelectionRepository>(
  'SelectionService',
  new SelectionRepositoryImpl()
)

serviceLocator.registerService<OrdersStreamRepository>(
  'OrdersStreamService',
  new OrdersStreamRepositoryImpl()
)

serviceLocator.registerService<OrderRateRepository>(
  'OrderRateService',
  new OrderRateRepositoryImpl()
)

serviceLocator.registerService<ShowcaseRepository>('ShowcaseService', new ShowcaseRepositoryImpl())

serviceLocator.registerService<ChannelUserRepository>(
  'ChannelUserService',
  new ChannelUserRepositoryImpl()
)

serviceLocator.registerService<CardRepository>('CardService', new CardRepositoryImpl())

serviceLocator.registerService<ActivityLogRepository>(
  'ActivityLogService',
  new ActivityLogRepositoryImpl()
)

serviceLocator.registerService<OperatorPriceChangeRepository>(
  'OperatorPriceChangeService',
  new OperatorPriceChangeRepositoryImpl()
)

serviceLocator.registerService<DisableBranchRepository>(
  'DisableBranchService',
  new DisableBranchRepositoryImpl()
)
serviceLocator.registerService<DriverRepository>('DriverService', new DriverRepositoryImpl())

serviceLocator.registerService<DriverDocumentRepository>(
  'DriverDocumentService',
  new DriverDocumentRepositoryImpl()
)

serviceLocator.registerService<DriverBlockRepository>(
  'DriverBlockService',
  new DriverBlockRepositoryImpl()
)
serviceLocator.registerService<DriverBreakRepository>(
  'DriverBreakService',
  new DriverBreakRepositoryImpl()
)
serviceLocator.registerService<DriverDayOffRepository>(
  'DriverDayOffService',
  new DriverDayOffRepositoryImpl()
)
serviceLocator.registerService<DriverPenaltyRepository>(
  'DriverPenaltyService',
  new DriverPenaltyRepositoryImpl()
)
serviceLocator.registerService<DriverRankingRepository>(
  'DriverRankingService',
  new DriverRankingRepositoryImpl()
)
serviceLocator.registerService<DriverDailyMetricRepository>(
  'DriverDailyMetricService',
  new DriverDailyMetricRepositoryImpl()
)
serviceLocator.registerService<DriverMetricAdjustmentRepository>(
  'DriverMetricAdjustmentService',
  new DriverMetricAdjustmentRepositoryImpl()
)
serviceLocator.registerService<RegionDailyAverageRepository>(
  'RegionDailyAverageService',
  new RegionDailyAverageRepositoryImpl()
)
serviceLocator.registerService<DriverRankTierConfigRepository>(
  'DriverRankTierConfigService',
  new DriverRankTierConfigRepositoryImpl()
)
serviceLocator.registerService<DriverRankSettingRepository>(
  'DriverRankSettingService',
  new DriverRankSettingRepositoryImpl()
)
serviceLocator.registerService<DriverEarningSettingRepository>(
  'DriverEarningSettingService',
  new DriverEarningSettingRepositoryImpl()
)

serviceLocator.registerService<SystemSalaryRepository>(
  'SystemSalaryService',
  new SystemSalaryRepositoryImpl()
)
serviceLocator.registerService<VehicleTemplateRepository>(
  'VehicleTemplateService',
  new VehicleTemplateRepositoryImpl()
)

serviceLocator.registerService<CancelShipmentReasonRepository>(
  'CancelShipmentReasonService',
  new CancelShipmentReasonRepositoryImpl()
)

serviceLocator.registerService<DistrictRepository>('DistrictService', new DistrictRepositoryImpl())

serviceLocator.registerService<JobRepository>('JobService', new JobRepositoryImpl())

serviceLocator.registerService<OrderRateReasonRepository>(
  'OrderRateReasonService',
  new OrderRateReasonRepositoryImpl()
)

serviceLocator.registerService<ShiftTemplateRepository>(
  'ShiftTemplateService',
  new ShiftTemplateRepositoryImpl()
)

serviceLocator.registerService<ShiftSettingRepository>(
  'ShiftSettingService',
  new ShiftSettingRepositoryImpl()
)

serviceLocator.registerService<ShiftRepository>('ShiftService', new ShiftRepositoryImpl())
serviceLocator.registerService<ShipmentRepository>('ShipmentService', new ShipmentRepositoryImpl())
serviceLocator.registerService<TrackOrderRepository>(
  'TrackOrderService',
  new TrackOrderRepositoryImpl()
)
serviceLocator.registerService<TrackOrderTwoRepository>(
  'TrackOrderTwoService',
  new TrackOrderTwoRepositoryImpl()
)
serviceLocator.registerService<PouchRepository>('PouchService', new PouchRepositoryImpl())
serviceLocator.registerService<SearchSettingRepository>(
  'SearchSettingService',
  new SearchSettingRepositoryImpl()
)

serviceLocator.registerService<DriverTeamRepository>(
  'DriverTeamService',
  new DriverTeamRepositoryImpl()
)
serviceLocator.registerService<OrderCancellationPolicyRepository>(
  'OrderCancellationPolicyService',
  new OrderCancellationPolicyRepositoryImpl()
)

serviceLocator.registerService<CouponsRepository>('CouponsService', new CouponsRepositoryImpl())

serviceLocator.registerService<CampaignsRepository>(
  'CampaignsService',
  new CampaignsRepositoryImpl()
)

serviceLocator.registerService<CashbackRepository>(
  'CashbackOffersService',
  new CashbackRepositoryImpl()
)

serviceLocator.registerService<ChatRepository>('ChatService', new ChatRepositoryImpl())

serviceLocator.registerService<UserGroupRepository>(
  'UserGroupService',
  new UserGroupRepositoryImpl()
)

serviceLocator.registerService<PrizeRepository>('PrizeService', new PrizeRepositoryImpl())

serviceLocator.registerService<SpinWheelRepository>(
  'SpinWheelService',
  new SpinWheelRepositoryImpl()
)

serviceLocator.registerService<PouchOperationRepository>(
  'PouchOperationService',
  new PouchOperationRepositoryImpl()
)

serviceLocator.registerService<UserNoteRepository>('UserNoteService', new UserNoteRepositoryImpl())

serviceLocator.registerService<SalesManRepository>('SalesManService', new SalesManRepositoryImpl())

serviceLocator.registerService<ItemUnitsRepository>(
  'ItemUnitsService',
  new ItemUnitsRepositoryImpl()
)

serviceLocator.registerService<BranchDeliverySettingRepository>(
  'BranchDeliverySettingService',
  new BranchDeliverySettingRepositoryImpl()
)

serviceLocator.registerService<UserAddressRepository>(
  'UserAddressService',
  new UserAddressRepositoryImpl()
)

serviceLocator.registerService<ZohoValueRepository>(
  'ZohoValueService',
  new ZohoValueRepositoryImpl()
)

serviceLocator.registerService<CustomMessageRepository>(
  'CustomMessageService',
  new CustomMessageRepositoryImpl()
)

serviceLocator.registerService<OrderPaymentTypeRepository>(
  'OrderPaymentTypeService',
  new OrderPaymentTypeRepositoryImpl()
)


serviceLocator.registerService<MealTiersRepository>(
  'MealTiersService',
  new MealTiersRepositoryImpl()
)

serviceLocator.registerService<CompaniesRepository>(
  'CompaniesService',
  new CompaniesRepositoryImpl()
)

serviceLocator.registerService<CompanyUsersRepository>(
  'CompanyUsersService',
  new CompanyUsersRepositoryImpl()
)

serviceLocator.registerService<MealRepository>('MealService', new MealRepositoryImpl())

serviceLocator.registerService<ScheduledProgramRepository>(
  'ScheduledProgramService',
  new ScheduledProgramRepositoryImpl()
)

serviceLocator.registerService<CancelMealReasonRepository>(
  'CancelMealReasonService',
  new CancelMealReasonRepositoryImpl()
)

serviceLocator.registerService<CancelPackageReasonRepository>(
  'CancelPackageReasonService',
  new CancelPackageReasonRepositoryImpl()
)

serviceLocator.registerService<AdjustmentRepository>(
  'AdjustmentService',
  new AdjustmentRepositoryImpl()
)

serviceLocator.registerService<AdjustmentReasonRepository>(
  'AdjustmentReasonService',
  new AdjustmentReasonRepositoryImpl()
)

serviceLocator.registerService<ExternalBranchesRepository>(
  'ExternalBranchesService',
  new ExternalBranchesRepositoryImpl()
)

serviceLocator.registerService<CancelDeliveryReasonRepository>(
  'CancelDeliveryReasonService',
  new CancelDeliveryReasonRepositoryImpl()
)

serviceLocator.registerService<CancelPackageReasonRepository>(
  'CancelPackageReasonService',
  new CancelPackageReasonRepositoryImpl()
)

serviceLocator.registerService<PackageRepository>('PackageService', new PackageRepositoryImpl())

serviceLocator.registerService<ReminderSettingRepository>(
  'ReminderSettingService',
  new ReminderSettingRepositoryImpl()
)

serviceLocator.registerService<MenuScreenRepository>(
  'MenuScreenService',
  new MenuScreenRepositoryImpl()
)

serviceLocator.registerService<RegionMenuSettingRepository>(
  'RegionMenuSettingService',
  new RegionMenuSettingRepositoryImpl()
)

serviceLocator.registerService<LiveMealRepository>('LiveMealService', new LiveMealRepositoryImpl())

serviceLocator.registerService<LiveMealRepositoryV2>(
  'LiveMealServiceV2',
  new LiveMealRepositoryImplV2()
)

serviceLocator.registerService<LivePackageRepository>(
  'LivePackageService',
  new LivePackageRepositoryImpl()
)

serviceLocator.registerService<LivePackageRepositoryV2>(
  'LivePackageServiceV2',
  new LivePackageRepositoryImplV2()
)

serviceLocator.registerService<RegionDeliveryRangeSettingRepository>(
  'RegionDeliveryRangeSettingService',
  new RegionDeliveryRangeSettingRepositoryImpl()
)

serviceLocator.registerService<MealCategoryRepository>(
  'MealCategoryService',
  new MealCategoryRepositoryImpl()
)

serviceLocator.registerService<TrendingSearchRepository>(
  'TrendingSearchService',
  new TrendingSearchRepositoryImpl()
)

serviceLocator.registerService<BranchPinRepository>(
  'BranchPinService',
  new BranchPinRepositoryImpl()
)

serviceLocator.registerService<DeliveryDiscountRepository>(
  'DeliveryDiscountService',
  new DeliveryDiscountRepositoryImpl()
)

serviceLocator.registerService<BranchMinimumCartSystemRepository>(
  'BranchMinimumCartSystemService',
  new BranchMinimumCartSystemRepositoryImpl()
)
